export const storageMap = [
	{ key: '24 Hour Storage', label: '24 Hour Storage Units' },
	{
		key: 'Climate Controlled Storage',
		label: 'Climate Controlled Storage Units',
	},
	{ key: 'Drive-Up Access Storage', label: 'Drive Up Storage Units' },
	{
		key: 'Storage With Electricity',
		label: 'Storage Units with Electricity',
	},
	{ key: 'Wine Storage', label: 'Wine Storage Units' },

	{ key: 'Mini Storage', label: 'Mini Storage Units' },
	{ key: 'Small Self Storage Units', label: 'Small Storage Units' },
	{ key: 'Medium Self Storage Units', label: 'Medium Storage Units' },
	{ key: 'Large Self Storage Units', label: 'Large Self Storage Units' },
	{ key: 'Storage Lockers', label: 'Storage Lockers' },

	{ key: 'Boat Storage', label: 'Boat Storage Units' },
	{ key: 'Car Storage', label: 'Car Storage Units' },
	{ key: 'RV Storage', label: 'RV Storage Units' },
	{ key: 'Motorcycle Storage', label: 'Motorcycle Storage Units' },
];
